module.exports = __webpack_public_path__ + "static/media/8OLA21.f2bc6085.jpg";